<script lang="ts">
	import Avatar from '$lib/Avatar.svelte';
	import { routes } from '$lib/routes';
	import type { Guest } from '$lib/server/supabase';

	interface Props {
		guest: Guest;
	}

	let { guest }: Props = $props();
</script>

<li class="flex-shrink-0 flex-grow-0">
	<div class="leading-none">
		{#if guest.user?.authUserId}
			<a href={routes.publicProfile(guest.userId)} class=" mb-1 flex w-fit items-center">
				{#if guest.user.avatarUrl}
					<Avatar
						user={{ userId: guest.userId, avatarUrl: guest.user.avatarUrl, name: guest.name }}
						class="mr-[0.4rem] translate-y-[0.1rem]"
						size="32px"
						innerSize="17px"
					/>
				{/if}
				<span class="highlight-text">
					{guest.name}
				</span>
			</a>
		{:else}
			{guest.name}
		{/if}
	</div>

	{#each guest.companions as companion}
		<div class="ml-[0.2rem] leading-none">
			& {companion}
		</div>
	{/each}
	{#if guest.comment}
		<div class="mt-0 text-xs text-gray-600">«{guest.comment}»</div>
	{/if}
</li>
